import { UI } from '@genial/components';
import { Button } from 'native-base';

import { useGlobalProductContext } from '../../contexts';

export const ProductsRefreshList = () => {
  const { product, hasSomeLoading, currentRefresher } = useGlobalProductContext();

  if (!product.hasRefresher) {
    return <></>;
  }

  return (
    <Button
      testID="refresh-equity-button"
      onPress={currentRefresher}
      isDisabled={hasSomeLoading}
      alignItems="center"
      justifyContent="center"
      variant="secondary"
      bg="white"
      w="52px"
      pr="inline.nano">
      <UI.Icon name="Refresh" size="xxs" />
    </Button>
  );
};
